import {lazy} from 'react';

import {ReportAccessGuard, useHasActiveHyundaiAuthorizationProfile} from '@dms/shared-aftersales';

const Report = lazy(() => import('./components/Report'));

export function HyundaiDbiReport() {
  const {hasActiveHyundaiAuthorizationProfile, isLoading, isError} =
    useHasActiveHyundaiAuthorizationProfile();

  return (
    <ReportAccessGuard
      hasAccess={hasActiveHyundaiAuthorizationProfile}
      isLoading={isLoading}
      isError={isError}
      data-testid="hyundaiDbiReport"
    >
      <Report />
    </ReportAccessGuard>
  );
}
